import React, { FC } from 'react';
import classnames from 'classnames';

import { useTheme } from '@glu/theming';

import useLocale from 'components/useLocale';

import useStyles from './Footer.styles';

interface Props {
  className: string;
  content: HTMLElement;
  sessionValue: string;
}

const FooterComponent: FC<Props> = ({ className, content, sessionValue }) => {
  const locale = useLocale();
  const { fdicImg, footer, footerContent } = useStyles();
  const { images: { logos = {} } = {} } = useTheme();

  if (sessionValue) {
    return null;
  }
  return (
    <footer className={classnames(footer, className)} data-qa="login-footer">
      <div className={footerContent}>
        {logos.fdic && (
          <img className={fdicImg} src={logos.fdic} alt={locale['fdicLogo.imgAlt']} />
        )}
        {content && <p>{content}</p>}
      </div>
    </footer>
  );
};

export default FooterComponent;
